export default "__VITE_ASSET__CLxbuHxL__"